import { normalizeToFullLocale } from './i18n';

export function formatIban(value: string): string {
    const v = value.replace(/\s+/g, '').toUpperCase();
    const parts = [];
    for (let i = 0; i < v.length; i += 4) {
        parts.push(v.substring(i, i + 4));
    }
    return parts.join(' ');
}

export function stripIban(value: string): string {
    return value.replace(/\s+/g, '');
}

const IBAN_LENGTH_BY_COUNTRY: Record<string, number> = {
    AD: 24,
    AL: 28,
    AT: 20,
    BE: 16,
    BG: 22,
    CH: 21,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    EE: 20,
    ES: 24,
    FI: 18,
    FR: 27,
    GB: 22,
    GI: 23,
    GR: 27,
    HR: 21,
    HU: 28,
    IE: 22,
    IS: 26,
    IT: 27,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MT: 31,
    NL: 18,
    NO: 15,
    PL: 28,
    PT: 25,
    RO: 24,
    RS: 22,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    VA: 22
};

const MIN_IBAN_LENGTH = 15;

export function getExpectedIbanLength(countryCode: string): number {
    return IBAN_LENGTH_BY_COUNTRY[countryCode.toUpperCase()] ?? MIN_IBAN_LENGTH;
}

export function isIbanComplete(iban: string): boolean {
    const stripped = stripIban(iban);
    if (stripped.length < 2) {
        return false;
    }
    const countryCode = stripped.substring(0, 2);
    return stripped.length >= getExpectedIbanLength(countryCode);
}

/**
 * Formats a monetary amount for display using the widget locale and the
 * session currency. Falls back to a plain `CURRENCY amount` string when no
 * currency is available or `Intl.NumberFormat` cannot format the input.
 */
export function formatCurrencyAmount(
    amount: number,
    currency: string | undefined,
    locale?: string
): string {
    if (!currency) {
        return amount.toFixed(2);
    }

    try {
        return new Intl.NumberFormat(normalizeToFullLocale(locale), {
            style: 'currency',
            currency
        }).format(amount);
    } catch {
        return `${currency} ${amount.toFixed(2)}`;
    }
}
